import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import Panel from '~components/Panel';
import Text, { ConstrainedText } from '~components/Text';

// Page Navigation
import PageNav from '~components/PageNav';
import MyrzahCard from '~components/PageCard/MyrzahCard';
import FannyCard from '~components/PageCard/FannyCard';

import { roundedImg } from '~theme';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Caleah, diagnostic à l’âge de 8 ans" desc="Description" />
      <Hero title="Caleah, diagnostic à l’âge de 8 ans">
        <StaticImage style={heroImgStyles} src="../../images/caleah.jpg" alt="" />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        Depuis mon diagnostic, je dois constamment vérifier ma glycémie, noter ce que je mange et compter les glucides. Je dois veiller à ce que mon taux ne soit ni trop élevé ni trop bas. C’est quelque chose dont je dois constamment m’occuper.
        </ConstrainedText>
        <ConstrainedText>
        Je veux que les gens sachent que ce n’est pas parce que je mange trop de sucre ou que j’ai de mauvaises habitudes de santé que je suis atteinte du DT1. Au contraire, on ne peut pas éviter de recevoir un diagnostic du DT1. Notre pancréas cesse de produire de l’insuline.
        </ConstrainedText>
        <ConstrainedText>
        Une meilleure recherche et des progrès dans le domaine du DT1 nous faciliteraient la vie. Et une guérison serait synonyme de liberté et de tranquillité d’esprit. Plus besoin de vérifier ma glycémie, de compter les glucides ou de m’inquiéter de mes taux de glucose dans le sang.
        </ConstrainedText>
        <ConstrainedText>
        Le fait d’être atteint du DT1 ne vous empêche pas de réaliser vos rêves. Vous pouvez faire ce que vous voulez tant que vous gérez correctement votre DT1.
        </ConstrainedText>
      </div>
      <Panel variant="blue">
        <div tw="grid gap-6 items-center lg:(grid-cols-2)">
          <div tw="lg:order-2 max-w-2xl">
            <StaticImage src="../../images/caleah-sm.jpg" alt="" style={roundedImg} />
          </div>
          <div tw="lg:order-1">
            <Text tw="text-2xl">
            Avoir le DT1 ne vous empêche pas de réaliser vos rêves. Vous pouvez faire ce que vous voulez tant que vous gérez correctement votre DT1.
            </Text>
          </div>
        </div>
      </Panel>
      <div tw="container">
        <PageNav previous={<MyrzahCard />} next={<FannyCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
